import { render, staticRenderFns } from "./WalkingMap.vue?vue&type=template&id=04cf2cf2"
import script from "./WalkingMap.vue?vue&type=script&lang=js"
export * from "./WalkingMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports